import { ContentBlocksList } from "@components/content_blocks_list/content_blocks_list";
import { Icon } from "@components/icon";
import { Loader } from "@components/loader/loader";
import { useFetchContentBlocks } from "@hooks/use_fetch_content_blocks";
import React, { type FC } from "react";

const ContentBlocksIndexPage: FC = () => {
  const { contentBlocks, loading } = useFetchContentBlocks();

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="content">
      <header>
        <h1>Content Blocks</h1>
        <div className="controls">
          <a
            href="/admin/content_block"
            className="add_new"
            title="Add new content block"
          >
            <Icon name="plus" />
          </a>
        </div>
      </header>
      <ContentBlocksList contentBlocks={contentBlocks} />
    </div>
  );
};

export { ContentBlocksIndexPage };
